import ErrorMessage from "@/errors/ErrorMessage";
import HomepageCta from "../HomepageCta";
import { messageCss } from "../ViewPageError.style";

const UnlicensedContentStudentUserError = () => {
  return (
    <ErrorMessage headline="">
      <p css={messageCss}>
        This content isn't available. Ask a teacher for help or visit the
        homepage to find available content.
      </p>

      <HomepageCta />
    </ErrorMessage>
  );
};

export default UnlicensedContentStudentUserError;
